import styled, { css } from 'styled-components'

export const Appear = styled.div<{
  isVisible?: boolean
  delay?: number
  hasTranslate?: boolean
}>`
  transition-property: ${({ hasTranslate = true }) => (hasTranslate ? 'opacity, transform' : 'opacity')};
  transition-duration: 0.3s, 0.5s;
  transition-delay: ${({ delay }) => delay && `${delay}s`};
  transition-timing-function: ease-out;
  opacity: 0;
  transform: ${({ hasTranslate = true }) => (hasTranslate ? 'translateY(30px)' : null)};

  ${({ isVisible, hasTranslate = true }) =>
    isVisible &&
    css`
      opacity: 1;
      transform: ${hasTranslate ? 'translateY(0)' : null};
    `}
`
